<template>
  <div class="p-4">
    <p class="font-italic mb-4">
      {{ text }}
    </p>
    <textarea name="" cols="30" rows="2" class="form-control"></textarea>
  </div>
</template>
<script>
export default {
  name: "CartInstruction",
  props: {
    text: {
      type: String,
      default:
        "If you have some information for the seller you can leave them in the box below"
    }
  }
};
</script>
